<template>
  <div class="device-list-bd">
    <div class="search-hd">
      <el-form
        :inline="true"
        @submit.native.prevent
      >
        <el-form-item style="float: right; margin-right: 0">
          <el-button
            class="table-set"
            style="vertical-align: top"
            @click="exportTable"
          >
            <i class="icon icon-daochu"></i>
          </el-button>
        </el-form-item>
        <!-- 配置项 -->
        <el-form-item
          style="float: right"
          :class="{ 'mr-0': false }"
        >
          <custom-column ref="column"></custom-column>
        </el-form-item>
        <!-- 搜索项 -->
        <el-form-item style="float: right">
          <el-input
            :placeholder="$t('crm_inventory_picking_device_list.he_tong_bian_hao')"
            v-model="formSearch.search"
            clearable
            @keyup.enter.native="onPageChange({ page: 1 })"
            style="width: 280px"
          >
            <template slot="append">
              <div @click="onPageChange({ page: 1 })">
                <i class="icon icon-search"></i>
              </div>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item style="float: right">
          <switch-button :link="link"></switch-button>
        </el-form-item>
      </el-form>
    </div>
    <switch-container
      ref="container"
      @search="onPageChange({ page: 1 })"
      @clear="clearFilter()"
    >
      <el-form
        :inline="true"
        label-position="top"
      >
        <!-- 产品型号 -->
        <el-form-item :label="$t('crm_inventory_picking_device_list.chan_pin_xing_hao')">
          <custom-select
            url="productCodeSelectList"
            v-model="formSearch.productCode"
            :props="{ label: 'productCode', value: 'productCode' }"
            placeholder=""
            width="100%"
          ></custom-select>
        </el-form-item>

        <!-- 发货日期 -->
        <el-form-item :label="$t('crm_inventory_picking_device_list.fa_huo_ri_qi')">
          <custom-date-picker
            v-model="formSearch.shipperTime"
            type="daterange"
            align="right"
            value-format="YYYY-MM-DD HH:mm:ss"
            :picker-options="pickerOptionDisAfter"
            style="width: 100%"
          ></custom-date-picker>
        </el-form-item>

        <!-- 收货日期 -->
        <el-form-item :label="$t('crm_inventory_picking_device_list.shou_huo_ri_qi')">
          <custom-date-picker
            v-model="formSearch.receivingTime"
            type="daterange"
            align="right"
            value-format="YYYY-MM-DD HH:mm:ss"
            :picker-options="pickerOptionDisAfter"
            style="width: 100%"
          ></custom-date-picker>
        </el-form-item>

        <!-- 出库方 -->
        <el-form-item :label="$t('crm_inventory_picking_device_list.chu_ku_fang')">
          <el-input
            v-model="formSearch.outOrgName"
            style="width: 100%"
          ></el-input>
        </el-form-item>

        <!-- 入库方 -->
        <el-form-item :label="$t('crm_inventory_picking_device_list.ru_ku_fang')">
          <el-input
            v-model="formSearch.inOrgName"
            style="width: 100%"
          ></el-input>
        </el-form-item>

      </el-form>
    </switch-container>
    <div class="table-bd">
      <custom-table
        ref="tb1"
        height="100%"
        type="radio"
        tableCode="crm_stock_devices"
        v-loading="isLoading"
        :data="tableList"
        :column="tableColumn"
        :index="true"
        :slots="['contractNo', 'customContractNo']"
        @filter="filterChange"
        @column="setColumn"
        columnRef="column"
        @sort="sortChange"
      >
        <template v-slot:contractNo="scope">
          <div
            class="cell-link"
            @click="jump('/contractdetail', { contractId: scope.row.bizId, contractClass: scope.row.bizClass, parentPath: $route.path })"
          >
            {{ scope.row.contractNo }}
          </div>
        </template>
        <template v-slot:customContractNo="scope">
          <div
            class="cell-link"
            @click="jump('/contractdetail', { contractId: scope.row.bizId, contractClass: scope.row.bizClass, parentPath: $route.path })"
          >
            {{ scope.row.customContractNo }}
          </div>
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page
        :total="totalRows"
        :page="formSearch.pageNum"
        :size="formSearch.pageSize"
        @change="onPageChange"
      ></custom-page>
    </div>

  </div>
</template>

<script>
import apis from '@/utils/apis';
// import contractRule from '@/utils/contractRule.js';
// import moment from 'moment';
import resetFormSearchMixins from '@/mixins/reset_form_search_mixins.js';

export default {
  name: 'contractManagement',
  props: {
    contractTypeData: {
      type: Array,
      default() {
        return [];
      },
    }, // 合同类型
    value: [String, Number],
    contractType: [String, Number],
  },
  components: {
  },
  mixins: [resetFormSearchMixins],
  data() {
    return {
      // tableCode: 'contract_list',
      formSearch: {
        search: '',
        orderType: '',
        orderBy: '',
        pageSize: 50,
        pageNum: 1,
        contractState: '',
        // contractType: ['20'],
        // bizClass: '20'
        // 高级搜索:

        // 产品型号
        productCode: '',
        // 发货日期
        shipperTime: null,
        // 收货日期
        receivingTime: null,
        // 出库方
        outOrgName: '',
        // 入库方
        inOrgName: '',

      },
      // 更多筛选
      searchFilters: false,
      totalRows: null,
      isLoading: false,
      tableList: [],
      // 操作

      // 审批
      dialogVisible1: false,
      dialogModel1: {},
      dialogData1: {},
      // 退回
      dialogVisible2: false,
      dialogModel2: {},
      dialogData2: {},
      // 发送电子合同 确认签署
      dialogVisible3: false,
      dialogModel3: {},
      dialogData3: {},

      //  租赁确认单
      dialogVisible5: false,
      dialogModel5: {},
      //  合同操作
      dialogVisible6: false,
      dialogModel6: {},
      //  修改业务负责人
      dialogVisible7: false,
      dialogModel7: {},

      // 用户身份
      // userInfo: {},
      // 操作
      visibleSet: '',
      dialogSetData: {},
      link: null,
    };
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo;
    },
  },
  mounted() {
    // this.getTableColumn();
    this.getFuncView(null, () => {
      setTimeout(() => {
        this.link = this.$refs.container;
      }, 500);
    });


    this.resetForm = JSON.stringify(this.form);
    this.resetFormSearch = JSON.stringify(this.formSearch);
    // this.userInfo = this.$store.state.userInfo;

    this.getTableList();
  },
  // activated() {
  //   this.getContract();
  //   // this.userInfo = this.$store.state.userInfo;
  // },
  methods: {
    getTableList() {
      this.isLoading = true;
      const reqData = this.getReqData();

      this.$getJSON(apis.transferOrderPageForDevice, reqData).then((res) => {
        this.totalRows = res.data.total;
        this.tableList = res.data.list || [];
      }).finally(() => {
        this.isLoading = false;
      });
    },
    getReqData() {
      const ret = {
        ...this.formSearch,
        loadRes: this.$route.path,
      };
      if (ret.shipperTime && ret.shipperTime.length) {
        ret.shipStartTime = ret.shipperTime[0];
        ret.shipEndTime = ret.shipperTime[1];

        delete ret.shipperTime;
      }
      if (ret.receivingTime && ret.receivingTime.length) {
        ret.receiveStartTime = ret.receivingTime[0];
        ret.receiveEndTime = ret.receivingTime[1];

        delete ret.receivingTime;
      }

      return ret;
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },

    exportTable() {
      const reqData = this.getReqData();
      delete reqData.pageSize;
      delete reqData.pageNum;

      this.$exportFlie(apis.transferOrderDeviceExport, reqData);
    }
  },
};
</script>

<style lang="scss" scoped>
.device-list-bd {
  padding-left: 16px;
  display: flex;
  height: 100%;
  flex-direction: column;
  overflow: hidden;
}
</style>
